import axios from "axios";
import { API_HOST } from "@/core/variables";
import { CreateMember, UpdateMember, UpdateOwner } from "@/model";


class MemberRepository {
    create = async (scenarioId: string, form: CreateMember) => {
        return axios
            .post(`${API_HOST}/scenarios/${scenarioId}/members`, {
                ...form
            });
    };

    find = async (scenarioId: string) => {
        return axios
            .get(`${API_HOST}/scenarios/${scenarioId}/members`)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    delete  = async (scenarioId: string, memberId: string) => {
        return axios.delete(`${API_HOST}/scenarios/${scenarioId}/members/${memberId}`);
    };

    update = async (scenarioId: string, memberId: string, form: UpdateMember) => {
        return axios.put(`${API_HOST}/scenarios/${scenarioId}/members/${memberId}`, {
            ...form
        });
    };
    
    updateOwner = async (scenarioId: string, form: UpdateOwner) => {
        return axios.put(`${API_HOST}/scenario/${scenarioId}/owner`, {
            ...form
        });
    };
}

const memberRepository = new MemberRepository();

export default memberRepository;
